<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <div class="success-box">
          <div style="display:inline-block;float:left;" class="sprite success">
          </div> Thank you for your purchase!
        </div>
        <p>
        <!--TODO: Put stuff that's in the email here -->
        <!-- TODO: Link to FAQ -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  mounted () {
    this.$store.dispatch('getStoredUser')
  },
  metaInfo: {
    title: 'Payment Success'
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// PaymentSuccess.vue?7eac6e6e